import { createAction, props } from '@ngrx/store';
import { NetworkLogEntry } from './network-logger.reducer';

export const logNetworkActivity = createAction(
  '[Network Logger] Log Network Activity',
  props<{ entry: NetworkLogEntry }>()
);

export const cleanUpNetworkActivityLogs = createAction(
  '[Network Logger] Clean Up Network Activity Logs',
  props<{ ids: string[] }>()
);

export const clearNetworkActivityLogs = createAction(
  '[Network Logger] Clear Network Activity Logs'
);
